"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MicrophoneSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7,15 L7,14 L9,14 L9.00029704,12.9725684 C6.7501788,12.7239814 5,10.8163788 5,8.5 L5,7 L6,7 L6,8.5 C6,10.4329966 7.56700338,12 9.5,12 C11.3685634,12 12.8951264,10.5357224 12.9948211,8.6920352 L13,8.5 L13,7 L14,7 L14,8.5 C14,10.8160341 12.2503421,12.7234136 10.0007074,12.9724574 L10,14 L12,14 L12,15 L7,15 Z M9.5,3 C10.8807119,3 12,4.11928813 12,5.5 L12,8.5 C12,9.88071187 10.8807119,11 9.5,11 C8.11928813,11 7,9.88071187 7,8.5 L7,5.5 C7,4.11928813 8.11928813,3 9.5,3 Z M9.5,4 C8.72030388,4 8.07955132,4.59488808 8.00686658,5.35553999 L8,5.5 L8,8.5 C8,9.32842712 8.67157288,10 9.5,10 C10.2796961,10 10.9204487,9.40511192 10.9931334,8.64446001 L11,8.5 L11,5.5 C11,4.67157288 10.3284271,4 9.5,4 Z" })));
};
MicrophoneSmall.displayName = 'MicrophoneSmall';
exports.default = MicrophoneSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MicrophoneSmall.js.map